/** Environment, read once and validated at boot. Mirrors the POS's, deliberately. */

type Env = {
  readonly apiBaseUrl: string;
  readonly isProduction: boolean;
};

function required(name: string, fallback?: string): string {
  const value = import.meta.env[name] as string | undefined;

  if (value === undefined || value.length === 0) {
    if (fallback !== undefined) return fallback;
    throw new Error(
      `${name} is not set. Copy .env.example to .env.local and fill it in before running the app.`,
    );
  }

  return value;
}

export const env: Env = {
  apiBaseUrl: required('VITE_API_BASE_URL', '/api/v1'),
  isProduction: import.meta.env.PROD,
};
